import React, { useContext, useEffect, useState } from "react";
import "./People_Behind_Work.css";
import {
  faFacebookF,
  faInstagram,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PeopleBehindWorks } from "../../../utils/apis/aboutus/Aboutus.js";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import Common_heading from "../../common/common_heading/Common_heading.js";

const PeopleBehindWork = () => {
  const { IMG_URL } = useContext(Context);
  const [peoplebehindwork, setPeopleBehindWork] = useState([]);

  const getPeopleBehindWork = async () => {
    const res = await PeopleBehindWorks();
    if (res?.success) {
      setPeopleBehindWork(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getPeopleBehindWork();
  }, []);

  return (
    <section className="people_section">
      <div className="container">
        <Common_heading
          title="OUR TEAM"
          subtitle="A group of dedicated minds working together to build something meaningful."
        />

        <div className="team_grid">
          <div className="row">
            {peoplebehindwork.map((member, index) => (
              <div className="col-xl-3 col-md-4 col-lg-4 col-sm-6 mb-3" key={index}>
                <div className="team_card">
                  <div className="image_wrapper">
                    <img
                      src={IDS?.IMG_URL + member?.image}
                      alt={member?.name}
                      className="team_img"
                    />

                    {/* Social icons visible over image hover or action */}
                    <div className="social_overlay">
                      {[
                        { icon: faFacebookF, link: "https://www.facebook.com" },
                        {
                          icon: faInstagram,
                          link: "https://www.instagram.com",
                        },
                        { icon: faXTwitter, link: "https://www.twitter.com" },
                      ].map((item, idx) => (
                        <a
                          key={idx}
                          href={item.link}
                          className="social_link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FontAwesomeIcon
                            icon={item.icon}
                            className="social_icon_img"
                          />
                        </a>
                      ))}
                    </div>
                  </div>

                  <div className="member_details">
                    <h3 className="member_name">{member?.name}</h3>
                    <h4 className="member_role">{member?.position}</h4>
                    {/* <p className="member_caption">
                  Nitesh Dabhade has over 7 years of experience in the IT and IT services industry. He has
successfully led multiple projects and teams while developing expertise in project
management, leadership, client engagement, and operational excellence.
                    </p> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PeopleBehindWork;
